import React, { useState } from 'react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { getStatusColor } from '@/features/products/utils'

type FriendlyNameMap = {
  [key: string]: string
}

//Mapeamento de nomes amigáveis para todos os enums
export const friendlyNameMaps: Record<string, FriendlyNameMap> = {
  previdenciarioStatus: {
    ATIVO: 'Ativo',
    CANCELADO: 'Cancelado',
    COBRANCA: 'Cobrança',
    COMPENSACAO_SUSPENSA: 'Compensação Suspensa',
    COMPENSADO: 'Compensado',
    CREDITO_ESGOTADO: 'Crédito Esgotado',
    DADOS_BANCARIOS_INVALIDOS: 'Dados Bancários Inválidos',
    DISTRATO: 'Distrato',
    DOCUMENTACAO_PENDENTE: 'Documentação Pendente',
    INADIMPLENTE: 'Inadimplente',
    JURIDICO: 'Jurídico',
    SEM_OPORTUNIDADE: 'Sem Oportunidade',
    JUDICIAL: 'Judicial',
    NEGATIVADO: 'Negativado',
    PAGO: 'Pago',
    PROCURACAO_CANCELADA: 'Procuração Cancelada',
    PROCURACAO_EXPIRADA: 'Procuração Expirada',
    RECALCULO: 'Recálculo'
  },
  aliquotaStatus: {
    AGUARDANDO_RFB: 'Aguardando RFB',
    ANALISE: 'Em Análise',
    ATIVO: 'Ativo',
    AVISO_DE_RECEBIMENTO: 'Aviso de Recebimento',
    CANCELADO: 'Cancelado',
    COBRANCA: 'Cobrança',
    DISTRATO: 'Distrato',
    DOCUMENTACAO_PENDENTE: 'Documentação Pendente',
    INADIMPLENTE: 'Inadimplente',
    JUDICIAL: 'Judicial',
    PAGO: 'Pago',
    PROCURACAO_CANCELADA: 'Procuração Cancelada',
    PROCURACAO_EXPIRADA: 'Procuração Expirada',
    PROTESTADO: 'Protestado',
    SUSPENSO: 'Suspenso'
  },
  produtosStatus: {
    AGUARDANDO_CALCULO: 'Aguardando Cálculo',
    AGUARDANDO_COMPENSACAO: 'Aguardando Compensação',
    AGUARDANDO_RFB: 'Aguardando RFB',
    ANALISE: 'Em Análise',
    ATIVO: 'Ativo',
    AVISO_DE_RECEBIMENTO: 'Aviso de Recebimento',
    CANCELADO: 'Cancelado',
    COBRANCA: 'Cobrança',
    CONTRATO_SUSPENSO: 'Contrato Suspenso',
    COMPENSACAO_SUSPENSA: 'Compensação Suspensa',
    COMPENSADO: 'Compensado',
    CREDITO_ESGOTADO: 'Crédito Esgotado',
    DADOS_BANCARIOS_INVALIDOS: 'Dados Bancários Inválidos',
    DISTRATO: 'Distrato',
    DOCUMENTACAO_PENDENTE: 'Documentação Pendente',
    INADIMPLENTE: 'Inadimplente',
    JURIDICO: 'Jurídico',
    SEM_OPORTUNIDADE: 'Sem Oportunidade',
    JUDICIAL: 'Judicial',
    NEGATIVADO: 'Negativado',
    PAGO: 'Pago',
    PROCURACAO_CANCELADA: 'Procuração Cancelada',
    PROCURACAO_EXPIRADA: 'Procuração Expirada',
    PROTESTADO: 'Protestado',
    RECALCULO: 'Recálculo',
    RESTITUIDO: 'Restituido',
    RESTITUIDO_PARCIAL: 'Restituido Parcial',
    SOLICITANDO_AUTORIZACAO: 'Solicitando Autorização',
    SUSPENSO: 'Suspenso'
  },
  boletoStatus: {
    CANCELADO: 'Cancelado',
    COBRANCA: 'Cobrança',
    INADIMPLENTE: 'Inadimplente',
    PAGO: 'Pago',
    PIX: 'Pix',
    SUBSTITUIDO: 'Substituído'
  },
  clientStatus: {
    INADIMPLENTE: 'Inadimplente',
    ATIVO: 'Ativo',
    BLOQUEADO: 'Bloqueado',
    NOVO: 'Novo',
    PROCURACAO_CANCELADA: 'Procuração Cancelada',
    PROCURACAO_EXPIRADA: 'Procuração Expirada',
    INATIVO: 'Inativo',
    JURIDICO: 'Jurídico',
    SEM_OPORTUNIDADE: 'Sem Oportunidade',
    PENDENTE: 'Pendente'
  },
  typeUsers: {
    ADMIN: 'Administrador',
    USUARIO: 'Usuário'
  },
  typeCargoAdmin: {
    ANALISTA: 'Analista',
    FINANCEIRO: 'Financeiro',
    JURIDICO: 'Jurídico',
    CEO: 'CEO'
  },
  typeCargoUser: {
    GERENTE: 'Parceiro Gestor',
    PARCEIRO: 'Parceiro Comercial',
    CEO: 'CEO'
  },
  typeCargo: {
    GERENTE: 'Parceiro Gestor',
    PARCEIRO: 'Parceiro Comercial',
    CEO: 'CEO',
    ANALISTA: 'Analista',
    FINANCEIRO: 'Financeiro',
    JURIDICO: 'Jurídico',
    GESTOR: 'Gestor'
  },
  typeServico: {
    EXCLUSAO_ICMS: 'Exclusão de ICMS ',
    EXCLUSAO_DE_ICMS_E_ST: 'Exclusão de ICMS e ST',
    EQUIPARACAO_HOSPITALAR: 'Equiparação Hospitalar',
    PREVIDENCIARIO: 'Previdenciário',
    SIMPLES_NACIONAL: 'Simples Nacional',
    LUCRO_REAL: 'Lucro Real',
    LUCRO_PRESUMIDO: 'Lucro Presumido',
    ALIQUOTA_ZERO: 'Alíquota Zero',
    DESPESAS_OPERACIONAIS: 'Despesas Operacionais',
    APURACAO_ST: 'Apuração ST',
    NEGOCIACAO_DE_PASSIVOS: 'Negociação de Passivos',
    PARCERIA_COMERCIAL: 'Parceria Comercial'
  }
}

export type StatusMapperEnumType =
  | 'previdenciarioStatus'
  | 'aliquotaStatus'
  | 'produtosStatus'
  | 'boletoStatus'
  | 'clientStatus'
  | 'typeUsers'
  | 'typeCargoAdmin'
  | 'typeCargoUser'
  | 'typeCargo'
  | 'typeServico'

interface StatusMapperProps {
  value: string
  enumType: StatusMapperEnumType
  className?: string
  showAsBadge?: boolean
}

export const StatusMapper: React.FC<StatusMapperProps> = ({ value, enumType, className, showAsBadge = true }) => {
  //Mapeamento do enum
  const map = friendlyNameMaps[enumType]

  if (!map) {
    console.warn(`Tipo de enum "${enumType}" não encontrado nos mapas de nomes amigáveis`)
    return <span className={className}>{value}</span>
  }

  //Pega o nome amigavel e mantem o valor normal
  const friendlyName = map[value] || value

  //Ve se badge é boole
  if (!showAsBadge) {
    return <span className={className}>{friendlyName}</span>
  }

  return (
    <Badge variant="outline" className={cn('font-medium', getStatusColor(value), className)}>
      {friendlyName}
    </Badge>
  )
}

interface StatusMapperInputProps {
  value: string
  onChange?: (value: string) => void
  enumType: StatusMapperEnumType
  className?: string
  placeholder?: string
  disabled?: boolean
  'aria-required'?: boolean
  'aria-invalid'?: boolean
  statusOptions?: { value: string; label: string }[]
}

export const StatusMapperInput: React.FC<StatusMapperInputProps> = ({
  value,
  onChange,
  enumType,
  className,
  placeholder = 'Selecione um status',
  disabled = false,
  'aria-required': ariaRequired,
  'aria-invalid': ariaInvalid
}) => {
  const [focused, setFocused] = useState(false)

  console.log(focused)
  //Obtém o mapa para o tipo de enum especificado
  const statusMap = friendlyNameMaps[enumType] || {}

  //Cria itens para a lista de opções
  const statusOptions = Object.entries(statusMap).map(([key, label]) => ({
    value: key,
    label: label
  }))

  const handleSelectChange = (newValue: string) => {
    if (onChange) {
      onChange(newValue)
    }
  }

  const containerClasses = cn('bg-input text-foreground', className)

  const selectClasses = cn('bg-input text-foreground')

  return (
    <div className={containerClasses}>
      <Select
        value={value}
        onValueChange={handleSelectChange}
        disabled={disabled}
        onOpenChange={open => setFocused(open)}
      >
        <SelectTrigger className={selectClasses} aria-required={ariaRequired} aria-invalid={ariaInvalid}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {statusOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default StatusMapper
